import React from 'react';

import styles from './mobile-max-typography.module.scss';
import { TypographyBase } from '../typography-base';
import { InnerTypographyProps } from '../types';

const MobileMaxTypography: React.FC<InnerTypographyProps> = (props) => {
  return <TypographyBase styles={styles} {...props} />;
};

export { MobileMaxTypography };
